import styles from './../styles.module.scss';
import skeleton from './styles.module.scss';
export default function SkeletonSubCard() {
  return (
    <div className={styles.container} style={{ gap: 12 }}>
      <div className={styles.container__header}>
        <div className={skeleton.chevron} />

        <p className={styles.container__header__textTitle}>
          <div className={skeleton.text} />
        </p>
      </div>
      <div className={styles.container__main}>
        <div className={skeleton.text} />
      </div>
    </div>
  );
}
